import { useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { SEO } from "@/components/SEO";
import { findGuideBySlug } from "@/data/guidesData";
import { buildHowToSchema } from "@/data/advancedSchemas";
import { getRelatedContent } from "@/data/relatedContent";
import { GenericHero } from "@/components/content/Hero";
import { StepsBlock } from "@/components/content/Steps";
import { FaqBlock } from "@/components/content/Faq";
import { CtaBlock } from "@/components/content/Cta";
import { RelatedContentBlock } from "@/components/content/RelatedContent";

export default function GuidePage() {
  const { pathname } = useLocation();
  // Format /guides/:slug → extract slug
  const slug = pathname.replace(/^\/guides\//, "");
  const guide = findGuideBySlug(slug);

  if (!guide) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center px-4">
          <AlertCircle className="h-16 w-16 text-red-600 mx-auto mb-4" />
          <h1 className="text-3xl font-bold mb-4">Guide introuvable</h1>
          <Link to="/guides">
            <Button>Voir tous les guides</Button>
          </Link>
        </div>
      </div>
    );
  }

  const schema = buildHowToSchema(guide);
  const description = guide.metaDescription;
  const keywords = `${guide.keyword}, ${guide.title.toLowerCase()}, guide ${guide.category}, Mediastore Niort, réparation Niort`;
  const breadcrumbs = [
    { name: "Accueil", path: "/" },
    { name: "Guides", path: "/guides" },
    { name: guide.title, path: `/guides/${guide.slug}` },
  ];

  return (
    <div className="min-h-screen" data-testid="guide-page">
      <SEO
        title={guide.metaTitle}
        description={description}
        keywords={keywords}
        path={`/guides/${guide.slug}`}
        schema={schema}
        breadcrumbs={breadcrumbs}
        type="article"
        publishedTime="2026-01-15"
        modifiedTime="2026-02-10"
      />

      <GenericHero
        category={guide.category}
        badge="Guide pratique"
        title={guide.title}
        intro={guide.intro}
        iconName={guide.icon}
        accentColor="red"
      />
      <StepsBlock steps={guide.steps} />
      <FaqBlock faqs={guide.faqs} />
      <RelatedContentBlock items={getRelatedContent(guide, "guide")} />
      <CtaBlock relatedSlugs={guide.relatedSlugs} />
    </div>
  );
}
